import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { pipe } from "fp-ts/lib/function";
import * as t from "io-ts";
import { fold } from "fp-ts/lib/Either";
import { singularityStore } from "@/store/store";

export async function setAsHomepage(pageId: number): Promise<boolean> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_singularity_set_as_homepage",
      decoder: t.type({ success: t.string }),
      dataToPost: { id: pageId }
    }),
    fold(
      () => false,
      _response => {
        singularityStore.setHomepageInWP(pageId);
        return true;
      }
    )
  );
}
